import { Box, Button, Flex, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import TcFormCards1 from "./TcFormCards1";
import TcFormCards2 from "./TcFormCards2";
import TcFormCards3 from "./TcFormCards3";

import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { BsCheck } from "react-icons/bs";
import isAllowed from "../../routing/isAllowed";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { applyTcForm } from "../../api";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../assets/svgs/Icons";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import dompurify from "dompurify";

export const PRODUCT_INITIAL_VALUES = {
  productId: "",
  invoiceNo: "",
  invoiceDate: "",
  lotNo: "",
  packedIn: "",
  netWeight: "",
  grossWeight: "",
  certifiedPercentage: "",
  certifiedLossPercentage: "",
  certifiedMaterialWeight: "",
  nonCertifiedMaterials: [],
  productInformation: "",
  inputs: [],
  process: [],
  sequenceNumber: 0,
};

export const INPUT_INITIAL_VALUES = {
  productClassificationId: "",
  inventoryDetails: "",
  consumedQuantity: null,
  tcId: "",
  procurementId: "",
  availableQuantity: null,
  heapId: "",
  heapName: "",
};

function TcForm() {
  const [step, setStep] = useState(0);
  const [processValues, setProcessValues] = useState([]);
  const [selectedProcessValue, setSelectedProcessValue] = useState([]);
  const [customProcessValue, setCustomProcessValue] = useState([]);
  const [checkedItems, setCheckedItems] = useState([false, true]);
  const [buyers, setBuyers] = useState([]);
  const [buyerId, setBuyerId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [consigneeUnitId, setConsigneeUnitId] = useState("");
  const [consigneeUnits, setConsigneeUnits] = useState("");
  const [consumption, setConsumption] = useState(null);
  const [ncConsumption, setNcConsumption] = useState(null);
  const [totalProductConsumption, setTotalProductConsumption] = useState(null);
  const [inputConsumption, setInputConsumption] = useState(0);
  const [inventoryOptions, setInventoryOptions] = useState(null);
  const [certifiedWeight, setCertifiedWeight] = useState(null);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [transportFile, setTransportFile] = useState(null);
  const [documentFile, setDocumentFile] = useState(null);
  const [invoiceDocTitle, setInvoiceDocTitle] = useState("");
  const [transportDocTitle, setTransportDocTitle] = useState("");
  const [documentTitle, setDocumentTitle] = useState("");
  const [totalGrossWeight, setTotalGrossWeigth] = useState(0);
  const [totalCertifiedWeight, setTotalCertifiedWeigth] = useState(0);
  const [totalNetWeight, setTotalNetWeigth] = useState(0);
  const [selectedConsigneeUnit, setSelectedConsigneeUnit] = useState({});
  const [selectedSellerUnit, setSelectedSellerUnit] = useState({});
  const [buyerCompany, setBuyerCompany] = useState([]);
  const [sellerUnits, setSellerUnits] = useState([]);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [sellerUnitId, setSellerUnitId] = useState("");
  const [productData, setProductData] = useState([]);
  const [productInfo, setProductInfo] = useState({});
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [productClassifications, setProductClassifications] = useState([]);
  const [inventoryDetails, setInventoryDetails] = useState([]);
  const [procNumbers, setProcNumbers] = useState([]);
  const [heapNumbers, setHeapNumbers] = useState([]);
  const [selectedInventoryIds, setSelectedInventoryIds] = useState([]);
  const [filteredInventoryIds, setFilteredInventoryIds] = useState([]);
  const [currentClassificationId, setCurrentClassificationId] = useState("");
  const [currentInventoryId, setCurrentInventoryId] = useState("");
  const [unitId, setUnitId] = useState("");
  const [topId, setTopId] = useState("");
  const [heapId, setHeapId] = useState("");
  const [selectedInvValue, setSelectedInvValue] = useState(null);
  const [tc1error1, setTc1Error1] = useState(false);
  const [tc1error2, setTc1Error2] = useState(false);
  const [tc1error3, setTc1Error3] = useState(false);
  const [tc2error1, setTc2Error1] = useState(false);
  const [tc2error2, setTc2Error2] = useState(false);
  const [tc2error3, setTc2Error3] = useState(false);
  const [tc2error4, setTc2Error4] = useState(false);
  const [tc2error5, setTc2Error5] = useState(false);
  const [tc2error6, setTc2Error6] = useState(false);
  const [tc2error7, setTc2Error7] = useState(false);
  const [tc2error8, setTc2Error8] = useState(false);
  const [tc2error9, setTc2Error9] = useState(false);
  const [tc2error10, setTc2Error10] = useState(false);
  const [tc2error11, setTc2Error11] = useState(false);
  const [tc2error12, setTc2Error12] = useState(false);
  const [tc2error13, setTc2Error13] = useState(false);
  const [tc2error14, setTc2Error14] = useState(false);
  const [tc2error15, setTc2Error15] = useState(false);
  const [productValues, setProductValues] = useState(PRODUCT_INITIAL_VALUES);
  const [inputValues, setInputValues] = useState(INPUT_INITIAL_VALUES);
  const [inputs, setInputs] = useState([]);
  const [isConsigneeChecked, setIsConsigneeChecked] = useState(false);
  const [isLastProcessorChecked, setIsLastProcessorChecked] = useState(false);
  const [declare, setDeclare] = useState(true);
  const [selectedProductDetails, setSelectedProductDetails] = useState({});

  const { companyDetails } = useSelector((state) => state.company);
  const { userData } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const getProcessList = async () => {
    let responseData = companyDetails?.data?.company_processes?.map((data) => {
      return {
        label: data?.name,
        value: data?.name,
        id: data?._id,
      };
    });
    console.log(companyDetails?.data?.company_processes);

    setProcessValues(responseData);
  };

  const handleDocumentSubmit = async () => {
    let invoiceReportRequest, transportReportRequest, documentReportRequest;

    if (!invoiceFile && !transportFile && !documentFile) {
      return;
    }
    const token = localStorage.getItem("cu_user");
    try {
      if (invoiceFile) {
        const invoiceReportData = new FormData();

        invoiceReportData.append("document", invoiceFile);
        invoiceReportData.append("doc_type", "OTHER");
        invoiceReportData.append("documentInfo", "OTHER");
        // invoiceReportData.append("documentId", invoiceDocTitle);

        invoiceReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: invoiceReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (transportFile) {
        const transportReportData = new FormData();

        transportReportData.append("document", transportFile);
        transportReportData.append("doc_type", "OTHER");
        transportReportData.append("documentInfo", "OTHER");
        // transportReportData.append("documentId", transportDocTitle);

        transportReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: transportReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (documentFile) {
        const legalReportData = new FormData();

        legalReportData.append("document", documentFile);
        legalReportData.append("doc_type", "OTHER");
        legalReportData.append("documentInfo", "OTHER");
        // legalReportData.append("documentId", documentTitle);

        documentReportRequest = await axios({
          method: "POST",
          url: `${process.env.REACT_APP_API_HOST}/api/document`,
          data: legalReportData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      }
      return {
        invoiceId: invoiceReportRequest?.data?.data?.id,
        transportId: transportReportRequest?.data?.data?.id,
        documentId: documentReportRequest?.data?.data?.id,
      };
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
    setIsLoading(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    let grossWeight = 0;
    let netWeight = 0;
    let certifiedWeightValue = 0;
    products?.forEach((product) => {
      if ("grossWeight" in product) {
        grossWeight += parseFloat(product?.grossWeight);
      }
      if ("netWeight" in product) {
        netWeight += parseFloat(product?.netWeight);
      }
      if (
        "certifiedMaterial" in product &&
        "certifiedWeight" in product?.certifiedMaterial
      ) {
        certifiedWeightValue += parseFloat(
          product.certifiedMaterial.certifiedWeight
        );
      }
    });

    setTotalGrossWeigth(grossWeight);
    setTotalNetWeigth(netWeight);
    setTotalCertifiedWeigth(certifiedWeightValue);
  }, [products]);

  const STEP_FORMS = [
    {
      id: 0,
      component: (
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setErrors,
        setFieldValue,
        setFieldError
      ) => (
        <TcFormCards1
          values={values}
          touched={touched}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleSubmit={handleSubmit}
          setErrors={setErrors}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          setIsConsigneeChecked={setIsConsigneeChecked}
          isConsigneeChecked={isConsigneeChecked}
          isLastProcessorChecked={isLastProcessorChecked}
          setIsLastProcessorChecked={setIsLastProcessorChecked}
          processValues={processValues}
          setProcessValues={setProcessValues}
          selectedProcessValue={selectedProcessValue}
          setSelectedProcessValue={setSelectedProcessValue}
          customProcessValue={customProcessValue}
          setCustomProcessValue={setCustomProcessValue}
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
          buyers={buyers}
          setBuyers={setBuyers}
          buyerId={buyerId}
          setBuyerId={setBuyerId}
          consigneeUnitId={consigneeUnitId}
          setConsigneeUnitId={setConsigneeUnitId}
          consigneeUnits={consigneeUnits}
          setConsigneeUnits={setConsigneeUnits}
          selectedConsigneeUnit={selectedConsigneeUnit}
          setSelectedConsigneeUnit={setSelectedConsigneeUnit}
          buyerCompany={buyerCompany}
          setBuyerCompany={setBuyerCompany}
          unitId={unitId}
          setUnitId={setUnitId}
          setTc1Error1={setTc1Error1}
          setTc1Error2={setTc1Error2}
          setTc1Error3={setTc1Error3}
          tc1error1={tc1error1}
          tc1error2={tc1error2}
          tc1error3={tc1error3}
          sellerUnits={sellerUnits}
          setSellerUnits={setSellerUnits}
          sellerOptions={sellerOptions}
          setSellerOptions={setSellerOptions}
          setSellerUnitId={setSellerUnitId}
          sellerUnitId={sellerUnitId}
          selectedSellerUnit={selectedSellerUnit}
          setSelectedSellerUnit={setSelectedSellerUnit}
        />
      ),
    },
    {
      id: 1,
      component: () => (
        <TcFormCards2
          setProductValues={setProductValues}
          productValues={productValues}
          inputValues={inputValues}
          setInputValues={setInputValues}
          inputs={inputs}
          setInputs={setInputs}
          productData={productData}
          setProductData={setProductData}
          products={products}
          setProducts={setProducts}
          productId={productId}
          setProductId={setProductId}
          productInfo={productInfo}
          setProductInfo={setProductInfo}
          setSelectedProductId={setSelectedProductId}
          selectedProductId={selectedProductId}
          consumption={consumption}
          setConsumption={setConsumption}
          ncConsumption={ncConsumption}
          setNcConsumption={setNcConsumption}
          totalProductConsumption={totalProductConsumption}
          setTotalProductConsumption={setTotalProductConsumption}
          inputConsumption={inputConsumption}
          setInputConsumption={setInputConsumption}
          heapNumbers={heapNumbers}
          setHeapNumbers={setHeapNumbers}
          heapId={heapId}
          setHeapId={setHeapId}
          certifiedWeight={certifiedWeight}
          setCertifiedWeight={setCertifiedWeight}
          productClassifications={productClassifications}
          setProductClassifications={setProductClassifications}
          inventoryDetails={inventoryDetails}
          setInventoryDetails={setInventoryDetails}
          procNumbers={procNumbers}
          setProcNumbers={setProcNumbers}
          tc2error1={tc2error1}
          setTc2Error1={setTc2Error1}
          selectedProductDetails={selectedProductDetails}
          setSelectedProductDetails={setSelectedProductDetails}
          tc2error2={tc2error2}
          tc2error3={tc2error3}
          tc2error4={tc2error4}
          tc2error5={tc2error5}
          tc2error6={tc2error6}
          tc2error7={tc2error7}
          tc2error8={tc2error8}
          tc2error9={tc2error9}
          tc2error10={tc2error10}
          tc2error11={tc2error11}
          tc2error12={tc2error12}
          tc2error13={tc2error13}
          tc2error14={tc2error14}
          tc2error15={tc2error15}
          processValues={processValues}
          setTc2Error2={setTc2Error2}
          setTc2Error3={setTc2Error3}
          setTc2Error4={setTc2Error4}
          setTc2Error5={setTc2Error5}
          setTc2Error6={setTc2Error6}
          setTc2Error7={setTc2Error7}
          setTc2Error8={setTc2Error8}
          setTc2Error9={setTc2Error9}
          setTc2Error10={setTc2Error10}
          setTc2Error11={setTc2Error11}
          setTc2Error12={setTc2Error12}
          setTc2Error13={setTc2Error13}
          setTc2Error14={setTc2Error14}
          setTc2Error15={setTc2Error15}
          inventoryOptions={inventoryOptions}
          setInventoryOptions={setInventoryOptions}
          topId={topId}
          setTopId={setTopId}
          selectedInvValue={selectedInvValue}
          setSelectedInvValue={setSelectedInvValue}
          selectedInventoryIds={selectedInventoryIds}
          setSelectedInventoryIds={setSelectedInventoryIds}
          filteredInventoryIds={filteredInventoryIds}
          setFilteredInventoryIds={setFilteredInventoryIds}
          currentClassificationId={currentClassificationId}
          setCurrentClassificationId={setCurrentClassificationId}
          currentInventoryId={currentInventoryId}
          setCurrentInventoryId={setCurrentInventoryId}
          unitId={unitId}
          selectedProcessValue={selectedProcessValue}
          setSelectedProcessValue={setSelectedProcessValue}
          customProcessValue={customProcessValue}
          setCustomProcessValue={setCustomProcessValue}
        />
      ),
    },
    {
      id: 2,
      component: () => (
        <TcFormCards3
          invoiceFile={invoiceFile}
          setInvoiceFile={setInvoiceFile}
          transportFile={transportFile}
          setTransportFile={setTransportFile}
          documentFile={documentFile}
          setDocumentFile={setDocumentFile}
          totalGrossWeight={totalGrossWeight}
          totalNetWeight={totalNetWeight}
          totalCertifiedWeight={totalCertifiedWeight}
          setDeclare={setDeclare}
          invoiceDocTitle={invoiceDocTitle}
          setInvoiceDocTitle={setInvoiceDocTitle}
          transportDocTitle={transportDocTitle}
          setTransportDocTitle={setTransportDocTitle}
          documentTitle={documentTitle}
          setDocumentTitle={setDocumentTitle}
        />
      ),
    },
  ];

  useEffect(() => {
    getProcessList();
  }, [companyDetails]);

  return (
    <Box marginBottom={"2rem"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          //#3958DC
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Transaction Certificate Form
        </Text>
      </Box>
      <Box
        marginTop={"1.5rem"}
        bg={"#52BBFF"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-2rem"
        marginRight={"-2.5rem"}
      >
        Transaction Certificate Form Details
      </Box>

      <Flex justifyContent={"center"} alignItems={"center"} mt={"3rem"}>
        {STEP_FORMS.map((curStep, index) => (
          <>
            <Box
              rounded={"full"}
              display={"flex"}
              justifyContent="center"
              alignItems={"center"}
              width="30px"
              height={"30px"}
              background={index === step ? "#52BBFF" : "transparent"}
            >
              <Box
                border={"3px solid #E2E8F0"}
                rounded={"full"}
                bg={
                  index < step
                    ? "#52BBFF"
                    : index === step
                    ? "#8fd0fd"
                    : "gray.400"
                }
                width="25px"
                height="25px"
                display={"flex"}
                justifyContent="center"
                alignItems={"center"}
              >
                {index < step && <BsCheck color="white" size={16} />}
              </Box>
            </Box>
            {!(index === STEP_FORMS.length - 1) && (
              <Box
                width="150px"
                height={"2px"}
                bg={index < step ? "#52BBFF" : "gray.400"}
              />
            )}
          </>
        ))}
      </Flex>

      <Formik
        initialValues={{
          unitId: "",
          certificationBodyId: "",
          buyerName: "",
          buyerCountry: "",
          buyerAddress: "",
          consigneeName: "",
          consigneeCountry: "",
          consigneeAddress: "",
          lastProcessorName: "",
          lastProcessorCountry: "",
          lastProcessorAddress: "",
        }}
        onSubmit={async (values, { resetForm }) => {
          setIsLoading(true);
          const documentResponse = await handleDocumentSubmit();
          if (products.length <= 0) {
            setIsLoading(false);
            return toast.info(
              "Please add at least one product before submitting."
            );
          }
          if (!invoiceFile || !transportFile || !documentFile) {
            setIsLoading(false);
            return toast.info("Please upload all supporting documents");
          }
          let tcFormValues = {
            unitId: values.unitId,
            programId: values.certificationBodyId,
            certificationBodyId: null,
            sellerId: userData?.companyId || null,
            //if registered buyer
            buyerId: buyerId || null,
            // if not registered buyer
            buyerDetails: {
              name: dompurify.sanitize(values.buyerName),
              country: dompurify.sanitize(values.buyerCountry),
              address: dompurify.sanitize(values.buyerAddress),
            },
            consigneeDetails: {
              name: dompurify.sanitize(values.consigneeName),
              country: dompurify.sanitize(values.consigneeCountry),
              address: dompurify.sanitize(values.consigneeAddress),
            },
            // lastProcessorDetails: {
            //   name: selectedSellerUnit?.name,
            //   country: selectedSellerUnit?.address?.country,
            //   address: selectedSellerUnit?.address?.raw_address,
            // }, as the last processor checkbox is removed and the last processor is always be the seller which in present in the organization so will use Id instead of details.
            lastProcessorId: sellerUnitId || null,
            //if registered buyer
            consigneeId: consigneeUnitId || null,
            // "inspectionBody": "642e61456bf8c220ecffc69e",
            // "countryOfDispatch": "India",
            documentsName: documentTitle,
            invoiceDocName: invoiceDocTitle,
            transportDocName: transportDocTitle,
            products: products,
            totalGrossWeight: totalGrossWeight,
            totalCertifiedWeight: totalCertifiedWeight,
            totalNetWeight: totalNetWeight,
            invoiceDocuments: documentResponse.invoiceId,
            transportDocuments: documentResponse.transportId,
            documents: documentResponse.documentId,
            declaration: declare,
            // processes: customProcessValue.map((values) => values.id),
          };
          if (
            !tcFormValues.buyerId &&
            !tcFormValues.buyerDetails.name &&
            !tcFormValues.buyerDetails.country &&
            !tcFormValues.buyerDetails.address
          ) {
            setIsLoading(false);
            return toast.error(
              "Please select buyer from the list or fill all the details"
            );
          }
          let response = await applyTcForm(
            tcFormValues,
            resetForm,
            setIsLoading
          );
          if (response?.data?.status === "success") {
            setProducts([]);
            setInvoiceFile(null);
            setDocumentFile(null);
            setTransportFile(null);
            setSelectedProcessValue([]);
            setCustomProcessValue([]);
            setSelectedProcessValue([]);
            setBuyerCompany([]);
            setSelectedConsigneeUnit({});
            setCheckedItems([false, true]);
            navigate("/client/transaction-certificates");
            setStep(0);
          }
        }}
        validationSchema={Yup.object().shape(
          checkedItems[1]
            ? {
                unitId: Yup.string().required("Unit is required"),
                certificationBodyId: Yup.string().required(
                  "Certification is required"
                ),
                buyerName: Yup.string().required("Buyer name is required"),
                buyerCountry: Yup.string().required(
                  "Buyer country is required"
                ),
                buyerAddress: Yup.string().required(
                  "Buyer address is required"
                ),
                consigneeName: Yup.string().required(
                  "Consignee name is required"
                ),
                consigneeCountry: Yup.string().required(
                  "Consignee country is required"
                ),
                consigneeAddress: Yup.string().required(
                  "Consignee address is required"
                ),
              }
            : {
                unitId: Yup.string().required("Unit is required"),
                certificationBodyId: Yup.string().required(
                  "Certification is required"
                ),
              }
        )}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
            validateForm,
            setErrors,
            setFieldValue,
            setFieldError,
          } = props;
          return (
            <>
              <form>
                {STEP_FORMS[step].component(
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  resetForm,
                  setErrors,
                  setFieldValue,
                  setFieldError
                )}
              </form>

              <Flex mt={"2rem"} gap="2rem" justifyContent={"center"}>
                <Button
                  onClick={() =>
                    step > 0 && setStep((prevStep) => prevStep - 1)
                  }
                  bg={step > 0 ? "#52BBFF" : "gray.200"}
                  _hover={step > 0 && { bg: "#3fa7eb" }}
                  color="white"
                  cursor={step > 0 ? "pointer" : "not-allowed"}
                >
                  <IoMdArrowRoundBack size={22} />
                </Button>
                {step === 2 ? (
                  // <Button
                  //   disabled={!declare || isLoading ? true : ""}
                  //   onClick={() => (isLoading ? {} : handleSubmit())}
                  //   bg={"#52BBFF"}
                  //   _hover={{ bg: "#3fa7eb" }}
                  //   color="white"
                  //   cursor={"pointer"}
                  // >
                  //   {isLoading ? (
                  //     <Loader width="25px" height="25px" />
                  //   ) : (
                  //     "Submit"
                  //   )}
                  // </Button>
                  <Button
                    disabled={
                      !declare ||
                      isLoading ||
                      (totalGrossWeight === 0 &&
                        totalNetWeight === 0 &&
                        totalCertifiedWeight === 0)
                    }
                    onClick={() => (isLoading ? {} : handleSubmit())}
                    bg={"#52BBFF"}
                    _hover={{ bg: "#3fa7eb" }}
                    color="white"
                    cursor={"pointer"}
                  >
                    {isLoading ? (
                      <Loader width="25px" height="25px" />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                ) : (
                  // <Button
                  //   onClick={() => {
                  //     validateForm().then((res) => {
                  //       if ((Object.keys(res).length > 0) || customProcessValue.length <= 0) {
                  //         toast.error("Please fill the required fields");
                  //       } else {
                  //         step < 2 && setStep((prevStep) => prevStep + 1);
                  //       }
                  //     });
                  //   }}
                  //   bg={step < 2 ? "#52BBFF" : "gray.200"}
                  //   _hover={step < 2 && { bg: "#3fa7eb" }}
                  //   color="white"
                  //   cursor={step < 2 ? "pointer" : "not-allowed"}
                  // >
                  //   <IoMdArrowRoundForward size={22} />
                  // </Button>
                  // <Button
                  //   onClick={() => {
                  //     validateForm().then((res) => {
                  //       if (
                  //         (Object.keys(res).length > 0 ||
                  //           customProcessValue.length <= 0) &&
                  //         step === 0 &&
                  //         !(
                  //           (values.consigneeName &&
                  //             values.consigneeCountry &&
                  //             values.consigneeAddress) ||
                  //           Object.keys(selectedConsigneeUnit).length > 0
                  //         )
                  //       ) {
                  //         toast.error("Please fill the required fields");
                  //       } else {
                  //         step < 2 && setStep((prevStep) => prevStep + 1);
                  //       }
                  //     });
                  //   }}
                  //   bg={step < 2 ? "#52BBFF" : "gray.200"}
                  //   _hover={step < 2 && { bg: "#3fa7eb" }}
                  //   color="white"
                  //   cursor={step < 2 ? "pointer" : "not-allowed"}
                  //   disabled={
                  //     step === 0 &&
                  //     !(
                  //       (values.consigneeName &&
                  //         values.consigneeCountry &&
                  //         values.consigneeAddress) ||
                  //       Object.keys(selectedConsigneeUnit).length > 0
                  //     )
                  //   }
                  // >
                  //   <IoMdArrowRoundForward size={22} />
                  // </Button>
                  <Button
                    onClick={() => {
                      validateForm().then((res) => {
                        if (
                          (Object.keys(res).length > 0 ||
                            customProcessValue.length <= 0) &&
                          step === 0 &&
                          !(
                            (values.consigneeName &&
                              values.consigneeCountry &&
                              values.consigneeAddress) ||
                            Object.keys(selectedConsigneeUnit).length > 0
                          )
                        ) {
                          toast.error("Please fill the required fields");
                        } else if (checkedItems[0]) {
                          if (!buyerId || !consigneeUnitId || !sellerUnitId) {
                            if (!buyerId) {
                              setTc1Error1(true);
                            }
                            if (!consigneeUnitId) {
                              setTc1Error2(true);
                            }
                            if (!sellerUnitId) {
                              setTc1Error3(true);
                            }
                            toast.error("Please fill the required fields");
                          } else {
                            step < 2 && setStep((prevStep) => prevStep + 1);
                          }
                        } else if (!sellerUnitId) {
                          if (!sellerUnitId) {
                            setTc1Error3(true);
                            toast.error("Please fill the required fields");
                          } else {
                            step < 2 && setStep((prevStep) => prevStep + 1);
                          }
                        } else {
                          step < 2 && setStep((prevStep) => prevStep + 1);
                        }
                      });
                    }}
                    bg={step < 2 ? "#52BBFF" : "gray.200"}
                    _hover={step < 2 && { bg: "#3fa7eb" }}
                    color="white"
                    cursor={step < 2 ? "pointer" : "not-allowed"}
                    disabled={
                      (step === 0 &&
                        !(
                          (values.consigneeName &&
                            values.consigneeCountry &&
                            values.consigneeAddress) ||
                          Object.keys(selectedConsigneeUnit).length > 0
                        )) ||
                      (step === 1 && products?.length <= 0)
                    }
                  >
                    <IoMdArrowRoundForward size={22} />
                  </Button>
                )}
              </Flex>
            </>
          );
        }}
      </Formik>
    </Box>
  );
}

export default isAllowed(TcForm);
